export default "__VITE_ASSET__52e22445__"